var map = {
	"./1st-place-medal.svg": "de2a",
	"./aquathlon-2.svg": "c246",
	"./aquathlon.svg": "8df3",
	"./arrow-left.svg": "76d5",
	"./arrow-right.svg": "5f9b",
	"./arrow-stroke.svg": "1be8",
	"./athletics-quadathlon.svg": "a2fd",
	"./athletics.svg": "42db",
	"./badge.svg": "ad4d",
	"./badminton.svg": "1503",
	"./basketball-jersey.svg": "1e4d",
	"./basketball.svg": "9b6c",
	"./beach-volleyball.svg": "1d75",
	"./biathlon.svg": "3232",
	"./bold.svg": "18b7",
	"./boxing.svg": "b03d",
	"./bug.svg": "048f",
	"./business.svg": "9abe",
	"./calendar.svg": "276b",
	"./camera.svg": "8a64",
	"./caret-right.svg": "9e7c",
	"./check-bold.svg": "72dc",
	"./check-circle-s.svg": "676f",
	"./check-circle.svg": "db44",
	"./chess.svg": "3115",
	"./climbing.svg": "2f24",
	"./clock.svg": "40ce",
	"./close-circle-s.svg": "6ac1",
	"./close.svg": "58a4",
	"./clouds.svg": "0fed",
	"./compass.svg": "26aa",
	"./copy.svg": "5e82",
	"./cross-country-skiing.svg": "8038",
	"./crown.svg": "be99",
	"./curling.svg": "f53e",
	"./cycling.svg": "cc9d",
	"./darts.svg": "4cd5",
	"./deposit.svg": "3522",
	"./dog-paw.svg": "8b92",
	"./double-right.svg": "00e5",
	"./down.svg": "ef8e",
	"./duathlon.svg": "f606",
	"./edit.svg": "582c",
	"./environment.svg": "bb03",
	"./equestrian-tourism.svg": "242b",
	"./exclamation-circle-s.svg": "3355",
	"./exclamation-circle.svg": "12d9",
	"./expand.svg": "4e51",
	"./external-link.svg": "3e9d",
	"./eye-invisible.svg": "36dc",
	"./eye.svg": "4111",
	"./facebook.svg": "34ad",
	"./family.svg": "4809",
	"./file-done.svg": "69c2",
	"./filter.svg": "a1d2",
	"./finish.svg": "73e6",
	"./fire.svg": "22c0",
	"./five-of-five.svg": "1828",
	"./global.svg": "b3c0",
	"./goalball.svg": "335f",
	"./gto.svg": "f723",
	"./gymnastics.svg": "a595",
	"./handball.svg": "f7c9",
	"./haze.svg": "7c9c",
	"./hockey.svg": "da81",
	"./id-card-bro.svg": "875a",
	"./image.svg": "1ea1",
	"./info-circle.svg": "f7be",
	"./instagram.svg": "c1c5",
	"./italic.svg": "2054",
	"./judo.svg": "1fad",
	"./left.svg": "2d94",
	"./line-chart.svg": "78fe",
	"./loading.svg": "1c2c",
	"./lock.svg": "d0fc",
	"./logout.svg": "8668",
	"./mail.svg": "0cc2",
	"./map.svg": "38f6",
	"./membership-card.svg": "d553",
	"./menu.svg": "c399",
	"./minus.svg": "40a0",
	"./mma.svg": "501f",
	"./more-horizontal.svg": "c175",
	"./mountain.svg": "10ca",
	"./navigation.svg": "d948",
	"./odnoklassniki.svg": "bf22",
	"./ordered-list.svg": "7619",
	"./padlock.svg": "dc9c",
	"./partly-cloudy-day.svg": "53d1",
	"./password.svg": "5618",
	"./phone.svg": "7b69",
	"./play-circle.svg": "38c9",
	"./play.svg": "09dc",
	"./plus.svg": "7aa7",
	"./pulse.svg": "ba5b",
	"./query-arrow.svg": "fec9",
	"./rain-cloud.svg": "a8ad",
	"./rain.svg": "4329",
	"./read.svg": "8e11",
	"./redo.svg": "3ec2",
	"./rhythmic-gymnastics.svg": "f075",
	"./right.svg": "98f9",
	"./rock-and-roll.svg": "6978",
	"./rocket.svg": "fc7b",
	"./rotate-left.svg": "a0a7",
	"./rotate-right.svg": "ab6a",
	"./rowing.svg": "e4aa",
	"./running.svg": "62d2",
	"./safety-float.svg": "bafc",
	"./search.svg": "c6a2",
	"./shoping-cart.svg": "2191",
	"./shopping-bag-2.svg": "248e",
	"./shopping-bag.svg": "766d",
	"./skiing.svg": "cc66",
	"./snow.svg": "9e68",
	"./snowboarding.svg": "4f4c",
	"./soccer-ball.svg": "0956",
	"./soccer.svg": "cd41",
	"./solution.svg": "232a",
	"./speedscating.svg": "0140",
	"./sports-gymnastics.svg": "6231",
	"./staircase.svg": "68bf",
	"./star.svg": "3c2e",
	"./storm.svg": "5f8a",
	"./strava.svg": "10a6",
	"./strike.svg": "e7ff",
	"./summer.svg": "b941",
	"./sup.svg": "94d5",
	"./swimming.svg": "6404",
	"./sync.svg": "92ae",
	"./table-tennis.svg": "49c3",
	"./table.svg": "d7ab",
	"./team.svg": "aea7",
	"./telegram.svg": "ebde",
	"./tennis.svg": "f841",
	"./tiktok.svg": "e32f",
	"./time-limit.svg": "a8b8",
	"./track-and-field.svg": "163e",
	"./triathlon.svg": "a44f",
	"./trophy.svg": "fbca",
	"./twitter.svg": "ec2ee",
	"./underline.svg": "bef9",
	"./undo.svg": "d7d3",
	"./unordered-list.svg": "7291",
	"./up.svg": "67b1",
	"./upload.svg": "5474",
	"./user-2.svg": "c6ed",
	"./user-edit.svg": "2dd5",
	"./user-groups.svg": "37b1",
	"./user.svg": "be92",
	"./vkontakte.svg": "ac1e",
	"./volleyball.svg": "ee50",
	"./walking.svg": "0fb6",
	"./warning-s.svg": "f124",
	"./warning.svg": "c026",
	"./weightlift.svg": "1024",
	"./windsurfing.svg": "e77f",
	"./withdrawal.svg": "56d1",
	"./wrestling.svg": "f5eb",
	"./youtube.svg": "5352"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "219f";